import axios from "axios";
import {toast} from "react-toastify";

export const sendOrder = (order) => {
    return async dispatch => {
        try {
            await axios.post(`https://holz-city.ru:444/order`, order);
            toast.success('Заказ получен! Мы перезвоним в ближайшее время.', {
                position: 'bottom-right',
                autoClose: false
            })
        } catch (e) {
            toast.error('При создание заказа возникли ошибки.', {
                position: 'bottom-right',
                autoClose: false
            })
        }

    }
}